var _g, _circle, _circle2, _g2, _g3, _path, _g4, _g5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTerms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 346,
    viewBox: "0 0 347 346",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3776_12480)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.777,
    y: 137.511,
    width: 79.571,
    height: 70.4024,
    rx: 6.54906,
    fill: "#53CD60"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 173.555,
    cy: 173.029,
    r: 135.357,
    stroke: "#5CDF6A",
    strokeOpacity: 0.1,
    strokeWidth: 74.5678,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.551,
    cy: 173.037,
    r: 105.858,
    fill: "url(#paint0_linear_3776_12480)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3776_12480)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 179.034,
    cy: 172.729,
    r: 131.361,
    stroke: "#53CD60",
    strokeOpacity: 0.45,
    strokeWidth: 4.42789,
    strokeLinecap: "round",
    strokeDasharray: "18.45 18.45",
    shapeRendering: "crispEdges"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3776_12480)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 173.559,
    cy: 173.03,
    r: 39.0751,
    fill: "#357453"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.047 93.5747H202.912C217.478 93.5747 229.285 105.383 229.285 119.948V203.816L145.932 239.702C132.398 245.529 117.535 234.829 118.767 220.145L127.373 117.544C128.165 108.102 123.844 98.9577 116.047 93.5747Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_di_3776_12480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.855 100.079C109.439 96.4181 112.557 93.6986 116.263 93.6181L118.231 93.5753C124.194 93.4456 128.951 98.5166 128.442 104.459L126.848 123.057H96.6992C101.592 123.057 105.76 119.501 106.53 114.669L108.855 100.079Z",
    fill: "#C3CFC4"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_3776_12480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.592 197.791H250.418V223.901C250.418 233.514 242.624 241.307 233.011 241.307H137.404C150.211 241.307 160.592 230.926 160.592 218.119V197.791Z",
    fill: "#C3CFC4"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 207.951,
    y: 124.755,
    width: 7.64331,
    height: 2.54777,
    rx: 1.27389,
    fill: "#9BD4B3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 144.258,
    y: 117.961,
    width: 23.7792,
    height: 2.54777,
    rx: 1.27389,
    fill: "#9BD4B3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 207.951,
    y: 120.509,
    width: 7.64331,
    height: 2.54777,
    rx: 1.27389,
    fill: "#9BD4B3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 140.859,
    y: 139.192,
    width: 23.7792,
    height: 2.54777,
    rx: 1.27389,
    fill: "#9BD4B3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 167.186,
    y: 139.192,
    width: 23.7792,
    height: 2.54777,
    rx: 1.27389,
    fill: "#9BD4B3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 194.363,
    y: 139.192,
    width: 22.9299,
    height: 2.54777,
    rx: 1.27389,
    fill: "#9BD4B3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 202.006,
    y: 135.795,
    width: 15.2866,
    height: 2.54777,
    rx: 1.27389,
    fill: "#9BD4B3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 190.115,
    y: 135.795,
    width: 9.34183,
    height: 2.54777,
    rx: 1.27389,
    fill: "#9BD4B3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3776_12480",
    x: 16.5522,
    y: 20.2858,
    width: 314.021,
    height: 304.853,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 58.6126,
    result: "effect1_foregroundBlur_3776_12480"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3776_12480",
    x: 11.5174,
    y: 10.4342,
    width: 335.032,
    height: 335.032,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.22179
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.9708
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3776_12480"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3776_12480",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3776_12480",
    x: 98.3232,
    y: 97.7936,
    width: 150.473,
    height: 150.473,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.0806
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3776_12480"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3776_12480",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_di_3776_12480",
    x: 86.4587,
    y: 86.8434,
    width: 45.8234,
    height: 43.5278,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.21844,
    dy: 0.292586
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.51103
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3776_12480"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3776_12480",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.92586,
    dy: 1.17034
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.80362
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3776_12480"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_3776_12480",
    x: 127.164,
    y: 191.062,
    width: 127.058,
    height: 57.5603,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.21844,
    dy: 0.292586
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.51103
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3776_12480"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3776_12480",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3776_12480",
    x1: 116.394,
    y1: 80.8826,
    x2: 284.078,
    y2: 245.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19253D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#203D77"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.bb104fc4e343a11e9f7461b4078249e2.svg";
export { ForwardRef as ReactComponent };